export const copyText = (text: string): void => {
  if ('clipboard' in navigator) {
    navigator.clipboard.writeText(text)
    return
  }

  const textArea = document.createElement('textarea')
  textArea.value = text
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand('copy')
  } catch (err) {
    // console.error('Fallback: Oops, unable to copy', err)
  }
  document.body.removeChild(textArea)
}

export const copyHtml = (htmlElement: HTMLElement) => {
  const selection = selectText(htmlElement)
  if (document.execCommand) {
    document.execCommand('copy')
  } else {
    copyText(selection.toString())
  }

  selection.removeAllRanges()
}

export const copyHtmlText = async (html: string, plainText: string): Promise<void> => {
  if (typeof ClipboardItem !== 'undefined' && navigator.clipboard?.write) {
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'text/html': new Blob([html], { type: 'text/html' }),
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'text/plain': new Blob([plainText], { type: 'text/plain' }),
        }),
      ])
      return
    } catch {
      // The browser can deny clipboard write, so fall back to copying a rendered selection
    }
  }

  const container = document.createElement('div')
  container.innerHTML = html
  container.style.position = 'fixed'
  container.style.top = '0'
  container.style.left = '0'
  container.style.opacity = '0'
  container.style.pointerEvents = 'none'

  document.body.appendChild(container)
  try {
    copyHtml(container)
  } finally {
    document.body.removeChild(container)
  }
}

export const selectText = (htmlElement: HTMLElement) => {
  const range = document.createRange()
  range.selectNode(htmlElement)

  const selection = window.getSelection()!
  selection.removeAllRanges()
  selection.addRange(range)
  return selection
}
